/*
 * Layout Name: About Intro
 * Desc:
 */
// libs
// assets
import React from "react"
import { Image } from "react-datocms"
import ReactMarkdown from "react-markdown"
import * as styles from "./AboutStory.module.scss"
import Section from "@components/structure/Section/Section"
// components
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"

const AboutStory = (props) => {
  const { ourStory } = props

  const storyItems =
    ourStory && ourStory.length
      ? ourStory.map((story) => (
          <div key={story.id} className={styles.story}>
            <div className={styles.text}>
              <SiteWrapper mobileOnly>
                <h2>{story.title}</h2>
                <ReactMarkdown>{story.text}</ReactMarkdown>
              </SiteWrapper>
            </div>
            <div className={styles.image}>{story.image && <Image lazyLoad={false} data={story.image.responsiveImage} />}</div>
          </div>
        ))
      : null

  return (
    <section className={styles.AboutStory}>
      <h1 className={styles.title}>Our Story</h1>
      <Section>
        <div className={styles.grid}>{storyItems}</div>
      </Section>
    </section>
  )
}

export default AboutStory
